var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FolderForm',{attrs:{"readonly":!_vm.hasPermission(_vm.Permission.DEPOSITORY_MANUAL_EDIT)}})}
var staticRenderFns = []

export { render, staticRenderFns }